<template>
  <div class="login-container">
    <div class="text-center pt-5">
      <img class="panelvue-logo" src="/logo.png" />
    </div>
    <form id="login-form" @submit.prevent="login">
      <input v-model="email" type="email" id="email" placeholder="Email address" autofocus />
      <input v-model="password" type="password" id="password" placeholder="Password" />
      <transition name="slide-fade" mode="out-in">
        <div v-if="error" class="text-danger text-center">{{error}}</div>
      </transition>
      <transition name="slide-fade" mode="out-in">
        <div v-if="!loading" key="button-panel" class="text-center">
          <button type="submit" class="w-100 mb-3 btn light-bg">Login</button>
          <!--<a href="register">Create an Account</a>-->
        </div>
        <div v-else key="loading-icon" class="text-center" style="height: 78px">
          <i class="fa fa-spin fa-spinner mt-3" />
        </div>
      </transition>
    </form>
  </div>
</template>

<script>
export default {
  name: "login",
  data: () => ({
    email: "",
    password: "",
    loading: false,
    error: ""
  }),
  methods: {
    login: async function() {
      if (this.email === "" || this.password === "") {
        this.error = "Fields may not be empty";
        return;
      }

      this.error = "";
      this.loading = true;

      try {
        const response = await this.$web.login(this.email, this.password);
        if (response.data) {
          this.$cookies.set("email", response.data.email);
          this.$cookies.set("token", response.data.token);
          this.$cookies.set("type", response.data.type);
          this.loading = false;
          this.error = "";
          this.$router.push({ name: "home" });
        } else {
          throw new Error("Unexpected result");
        }
      } catch (e) {
        console.log(e);
        this.loading = false;
        this.error = "Invalid login attempt";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/custom.scss";

.panelvue-logo {
  max-width: 300px;
}

#login-form {
  max-width: 300px;
  margin: auto;
  font-size: inherit;
  font-family: Roboto, Arial, Helvetica, sans-serif, "Segoe UI Emoji",
    "Segoe UI Symbol";
}

.login-container {
  input {
    font-size: inherit;
    width: 100%;
    max-width: 100%;
    padding: 10px 10px;
    box-sizing: border-box;
    border-radius: 2px;
    border: none;
    margin-bottom: 5px;
    background-color: white;
  }
}

.fa-spin {
  color: white;
}
</style>